













































import { UmbrellaType } from "@/models/products/umbrella";
import { Component } from "vue-property-decorator";
import Collections from "./Collections";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import ConfigCodeButton from "@/components/elements/ConfigCodeButton.vue";
import { getImg } from "@/utility/helpers";
@Component({
  components: {
    AccordionSection,
    ConfigCodeButton
  }
})
export default class UmbrellaMenu extends Collections {
  protected getImg = getImg;
  protected umbrellaType = UmbrellaType;
}
